<template>
  <div class="layout">
    <div class="admin-nav">
      <normal-nav></normal-nav>
    </div>
    <div class="cont-normal">
      <div class="cont-normal-left">
        <left-menu></left-menu>
      </div>
      <div class="cont-normal-right">
        <div class="normal-right-inner-wrap" :class="{'normal-right-inner-wrap--nopage': noPage}">
          <div class="normal-right-inner">
            <router-view></router-view>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import normalNav from './components/normalNav'
import leftMenu from './components/leftMenu'
export default {
  name: 'index',
  components: {
    normalNav,
    leftMenu
  },
  computed: {
    noPage() {
      return this.$route.meta.noPage
    }
  }
}
</script>

<style lang="scss">
  .normal-right-inner {
    .page-table-box .v-page-ul {
      position: fixed;
      bottom: 20px;
      left: 0;
      width: auto;
      min-width: 940px;
      left: 200px;
      right: 20px;
    }
    .el-loading-mask {
      .el-loading-spinner {
        position: fixed;
        left: 80px;
      }
    }
  }
</style>
